import { Link } from "react-router-dom";
import {
  UserCheck, Zap, BadgeCheck, ClipboardCheck, Settings, Leaf, Clock, GraduationCap, Handshake, ArrowRight, HelpCircle,
} from "lucide-react";
import { ENGAGEMENTS } from "@/lib/content";

const ICONS = { UserCheck, Zap, BadgeCheck, ClipboardCheck, Settings, Leaf, Clock, GraduationCap, Handshake };
const Icon = ({ name, ...p }) => {
  const C = ICONS[name] || UserCheck;
  return <C {...p} />;
};

export default function PourquoiNous() {
  return (
    <div data-testid="pourquoi-page">
      {/* HERO */}
      <section className="bg-ink text-white relative overflow-hidden nx-hero-pourquoi" style={{ paddingTop: 200, paddingBottom: 120 }}>
        <div className="absolute inset-0 nx-hero-grid opacity-50"></div>
        <div
          className="absolute -top-32 -right-32 w-[500px] h-[500px] rounded-full opacity-20"
          style={{ background: "radial-gradient(circle, #00C8FF 0%, transparent 70%)" }}
        ></div>
        <div className="nx-container relative">
          <div className="max-w-3xl nx-fade-up">
            <span className="nx-overline">Pourquoi nous choisir</span>
            <h1 className="text-white" style={{ marginTop: 24, marginBottom: 32 }}>
              On s'occupe de tout. <span style={{ color: "#00C8FF" }}>Vous, occupez-vous du reste.</span>
            </h1>
            <p className="text-mist" style={{ fontSize: 20, marginBottom: 0 }}>
              Nettoyage, entretien, maintenance&nbsp;: NOVANEXT gère l'intégralité de vos prestations avec un chef de site dédié, une réponse sous 24h et un contrôle qualité continu. Vous n'avez plus qu'une chose à faire&nbsp;: nous faire confiance et constater le résultat.
            </p>
          </div>
        </div>
      </section>

      {/* 5 ENGAGEMENTS — LISTE CANONIQUE */}
      <section className="bg-white nx-arch-grid-light" style={{ paddingTop: 120, paddingBottom: 120 }}>
        <div className="nx-container">
          <div className="max-w-2xl">
            <span className="nx-overline">Cinq engagements concrets</span>
            <h2 style={{ marginTop: 24, marginBottom: 32 }}>Ce que vous obtenez, à chaque intervention.</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3" style={{ gap: 30, marginTop: 64 }}>
            {ENGAGEMENTS.map((r, i) => (
              <div key={r.title} className={`nx-card nx-fade-up nx-delay-${(i % 4) + 1}`} data-testid={`engagement-${i}`}>
                <div className="nx-icon-wrap"><Icon name={r.icon} size={26} strokeWidth={1.75} /></div>
                <h4 style={{ marginTop: 24, marginBottom: 16 }}>{r.title}</h4>
                <p style={{ fontSize: 16, marginBottom: 0 }}>{r.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA — orienté mise en relation humaine (cohérent avec la page preuve/différenciation) */}
      <section className="bg-ink text-white nx-cta-pourquoi-bg" style={{ paddingTop: 120, paddingBottom: 120 }}>
        <div className="nx-container text-center">
          <span className="nx-overline">Passons à la pratique</span>
          <h2 className="text-white" style={{ marginTop: 24, marginBottom: 24, maxWidth: 800, marginLeft: "auto", marginRight: "auto" }}>
            Convaincu(e) ? Échangeons 20 minutes pour en juger sur votre cas concret.
          </h2>
          <p className="text-mist" style={{ maxWidth: 640, marginLeft: "auto", marginRight: "auto", marginBottom: 40 }}>
            Un appel court, ciblé sur votre site et vos contraintes réelles. À l'issue, vous saurez précisément ce que nous pouvons vous apporter — ou pas.
          </p>
          <div className="flex flex-wrap gap-4 justify-center">
            <Link to="/contact" className="nx-btn nx-btn-primary" data-testid="pourquoi-cta">
              Parler à un conseiller <ArrowRight size={18} strokeWidth={2} />
            </Link>
            <Link to="/faq" className="nx-btn nx-btn-outline" data-testid="pourquoi-faq">
              <HelpCircle size={18} strokeWidth={1.75} /> Consulter les questions fréquentes
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
